import * as React from "react";
import XPageProd from "./components/XPage/prod";
import XoraiaProvider from "./context/XoraiaProvider";

const XPage = React.lazy(() => import("./components/XPage"));
const SaveButton = React.lazy(() => import("./components/SaveButton"));
const AddButton = React.lazy(() => import("./components/AddBtn"));
const ShowPreview = React.lazy(() => import("./components/ShowPreview"));
const ToggleBreakPoints = React.lazy(
  () => import("./components/ToggleBreakPoints")
);
const Browser = React.lazy(() => import("./components/Browser"));
const SwitchPage = React.lazy(() => import("./components/SwitchPage"));
const XArticleProvider = React.lazy(() => import("./context/XArticleProvider"));
const XArticle = React.lazy(() => import("./components/common/XArticle"));
const XEditor = React.lazy(() => import("./components/XEditor"));

export {
  XoraiaProvider,
  XArticleProvider,
  XPage,
  SaveButton,
  AddButton,
  ShowPreview,
  ToggleBreakPoints,
  Browser,
  SwitchPage,
  XArticle,
  // PROD COMPONENTS
  XPageProd,
  XEditor,
};

export * from "./hooks/useXoraia";
export * from "./hooks/useCart";
export * from "./hooks/useXPath";

// IMPORTANT TYPES
export * from "./utils/types/common/components.types";

export { TXFooterProps } from "./utils/interfaces/common/XFooter.interfaces";
export { TXHeaderProps } from "./utils/interfaces/common/XHeader.interfaces";
